import { Injectable } from '@angular/core';
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ExportService {
  constructor() {}
  getLatestStatus(element:any): string {
    console.debug("element",element)
    let latestStatus = null;
    let latestDate = null;
    for (const key in element.status) {
      if (element.status.hasOwnProperty(key)) {
        const status = element.status[key];
        if (!latestDate || status.date > latestDate) {
          latestDate = status.date;
          latestStatus = status.value;
        }
      }
    }
    
    return latestStatus;
  }


  exportToCsv(filename: string, rows: object[],header:any,title:string) {
    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: true,
      title: title,
      useBom: true,
      noDownload: false,
      headers:header
    };

    new AngularCsv(rows, filename, options);
  }

  exportToXlsx(filename: string, rows: object[],header:any,title1:string) {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
    const workbook: XLSX.WorkBook = {
      Sheets: { 'data': worksheet },
      SheetNames: ['data']
    };

    const title = [[title1]];
    XLSX.utils.sheet_add_aoa(worksheet, title, { origin: 'A1' });

    const emptyRow = [[]];
    XLSX.utils.sheet_add_aoa(worksheet, emptyRow, { origin: -1 });

    const headers = header;
    XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: -1 });

    XLSX.utils.sheet_add_json(worksheet, rows, { origin: -1, skipHeader: true });

    headers.forEach((_, colIndex) => {
      const cellAddress = XLSX.utils.encode_cell({ c: colIndex, r: 2 });
      if (!worksheet[cellAddress]) return;
      if (!worksheet[cellAddress].s) worksheet[cellAddress].s = {};
      worksheet[cellAddress].s.font = { bold: true };
    });

    worksheet['!merges'] = worksheet['!merges'] || [];
    worksheet['!merges'].push({
      s: { r: 0, c: 0 },
      e: { r: 0, c: headers.length - 1 }
    });

    const titleCell = XLSX.utils.encode_cell({ r: 0, c: 0 });
    if (worksheet[titleCell]) {
      worksheet[titleCell].s = worksheet[titleCell].s || {};
      worksheet[titleCell].s.alignment = { horizontal: 'center' };
    }

    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, filename);
}

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  }

  exportToPdf(filename: string, rows: any[],headers:any,title,dataNew) {
    const doc = new jsPDF('p', 'pt');
    console.log(rows, "rows");
    doc.setFontSize(14);
    doc.text(title, doc.internal.pageSize.getWidth() / 2, 30, { align: 'center' });
  
    const data =dataNew 
  
    doc.text(' ', 10, 40);
  
    const pageWidth = doc.internal.pageSize.getWidth();
    const tableWidth = pageWidth - 40; 
    const columnCount = 10;
    const cellWidth = tableWidth / columnCount;
  
    autoTable(doc, {
      head: [headers],
      body: data,
      startY: 50,
      headStyles: { fillColor: [41, 128, 185], textColor: 255, fontStyle: 'bold' },
      styles: { fontSize: 10, cellPadding: 5 }, 
      margin: { top: 60 },
      columnStyles: {
        0: { cellWidth: cellWidth }, 
        1: { cellWidth: cellWidth }, 
        2: { cellWidth: cellWidth }, 
        3: { cellWidth: cellWidth }, 
        4: { cellWidth: cellWidth }, 
        5: { cellWidth: cellWidth },
        6: { cellWidth: cellWidth }, 
        7: { cellWidth: cellWidth }, 
        8: { cellWidth: cellWidth }, 
        9: { cellWidth: cellWidth }
      },
      tableWidth: 'wrap',
    });
  
    doc.save(`${filename}.pdf`);
  }
}

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';


